
import { z } from 'zod';

// Contact form validation schema
export const contactFormSchema = z.object({
  name: z.string().min(2, "Name must be at least 2 characters").max(100, "Name cannot exceed 100 characters"),
  email: z.string().email("Invalid email address"),
  phone: z.string().optional(),
  company: z.string().optional(),
  message: z.string().min(10, "Message must be at least 10 characters").max(2000, "Message cannot exceed 2000 characters"),
  preferredContact: z.enum(['email', 'phone', 'either']).optional(),
  captchaToken: z.string().min(1, "Please complete the captcha verification")
});

export type ContactFormValues = z.infer<typeof contactFormSchema>;
